import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { DsSelectorBottomSheetComponent } from "./ds-selector-bottom-sheet.component";
import { DsOptionCardModule } from "../ds-option-card/ds-option-card.module";
import { DsButtonModule } from "../ds-button/ds-button.module";

@NgModule({
  declarations: [DsSelectorBottomSheetComponent],
  imports: [CommonModule, OverlayModule, PortalModule, DsOptionCardModule, DsButtonModule],
  exports: [DsSelectorBottomSheetComponent],
})
export class DsSelectorBottomSheetModule {}
